import { render, staticRenderFns } from "./SubdepList.vue?vue&type=template&id=1282f9d5&scoped=true"
import script from "./SubdepList.vue?vue&type=script&lang=js"
export * from "./SubdepList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1282f9d5",
  null
  
)

export default component.exports